import { APIRoute } from '@/modules/utils'
import { NotificationCards } from '@/data'

export const Route: APIRoute = {
  method: 'GET',
  path: `/v2/notification_cards`,
}

export type Response = NotificationCards
